import { render, staticRenderFns } from "./Exibir.vue?vue&type=template&id=952c3c84&"
import script from "./Exibir.vue?vue&type=script&lang=js&"
export * from "./Exibir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports